import logoMinatomachi from "../../../assets/logo-minatomachi.png";
import conceptIllustration from "../../../assets/hero-kobe-port-illustration.jpg";

export default function Concept() {
  return (
    <section id="concept" className="relative py-20 md:py-24 bg-background-50">
      {/* rope bottom — echoes the rope/gold motif used site-wide (NEWS, Menu, OpenGift, Footer) */}
      <div className="rope-border absolute bottom-0 left-0 right-0 opacity-90" />
      <div className="max-w-6xl mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-10 md:gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-8 bg-primary-500" />
            <span className="font-label tracking-widest text-primary-600 text-sm">
              CONCEPT
            </span>
          </div>

          <p className="font-heading font-black text-2xl md:text-4xl text-primary-600 leading-tight">
            神戸の港町らしい活気を<br />そのまま一皿に。
          </p>

          <h2 className="leading-tight mt-6">
            <img
              src={logoMinatomachi}
              alt="ミナトマチカレー"
              width={1253}
              height={425}
              loading="lazy"
              className="w-full max-w-[320px] md:max-w-[400px]"
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.15))' }}
            />
            <span className="block font-heading font-black text-2xl md:text-3xl text-foreground-950 mt-3">とは？</span>
          </h2>
          <div className="mt-6 text-foreground-800 leading-relaxed">
            <p>
              濃厚なカレーをご飯に豪快にかけ、食べ応えのある肉をたっぷり盛り付ける
              "肉が主役のごちそうカレー"。
              <br />
              神戸洋食の親しみやすさを一皿に込め、仕事の合間にも旅行の思い出にも、しっかり満足できるボリュームと旨さを届けます。
            </p>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {["神戸", "港町", "スパイス", "カジュアル", "フードコート"].map(
              (t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-heading font-bold"
                >
                  #{t}
                </span>
              )
            )}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -top-6 -left-4 w-16 h-16 rounded-full bg-accent-500 text-secondary-900 font-heading font-black text-xs flex flex-col items-center justify-center rotate-[-8deg]">
            <span>KOBE</span>
            <span>CURRY</span>
          </div>
          <div className="rounded-2xl overflow-hidden border-4 border-background-50 bg-background-100 aspect-[4/3]">
            <img
              src={conceptIllustration}
              alt="神戸港のイラスト"
              loading="lazy"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="mt-4 dotted-marine" />
        </div>
      </div>
    </section>
  );
}